<!-- current activity box -->
<fieldset class="activityarea activity" data-help="action" disabled={stunned} style="border: 3px solid {actcolor}">
	<h3 onclick={show_card}>{(!stunned) ? "Handlung:" : "Benommen"}</h3>
	<div class="activityarea-inner">
		{#if activity?.rolls}
			<div class=rollBox oncontextmenu={revise_activity}>
				<img src="/static/buttons/D100.png" alt="Wurf">
				<span class=roll class:tight={roll === 100}>{roll.toString()?.padStart(2, "0")}</span>
			</div>
		{/if}
		<div class="amends">
			{#each amends as eff}
				<p class={eff.kind} title={eff.summary}>{eff.name}</p>
			{/each}
		</div>
		<div class="actdata" class:locked={activity && !user.isMaster} onchange={change_activity}>
			<!-- 1st line: current action selector, aim and dur input -->
			<ActionSelect currency=main action={activity?.action} />
			<input id=aim type=text value={activity?.aim?.str ?? activity?.aim} class="text lockable" placeholder="Ziel" list="fighterList"
						 onfocus={(e) => e.target.select()} onchange={check_aim}>
			{#if user.isMaster}
				<div>
					<input id=dur type="number" value={activity?.dur} class="text dur" placeholder="AD" min="0" max="30"/>
				</div>
				<!-- 2nd line: MASTER ONLY activity description or info on chance + difficulty -->
				<div id=evaluation class="doublespan">
					<Input field=pro help="evaluation" value={evaluation.pro} type=number disabled />
					<span>{(evaluation.con > 0) ? "–" : "+"}</span>
					<Input field=con help="evaluation" value={Math.abs(evaluation.con)} type=number disabled />
					<span>{(evaluation.mod >= 0) ? "+" : "–"}</span>
					<Input field=mod help="evaluation" value={Math.abs(evaluation.mod)} type=number disabled />
					<span>{(evaluation.bon >= 0) ? "+" : "–"}</span>
					<Input field=bon value={Math.abs(evaluation.bon)} type=number style="background-color: #333" />
					<span> > </span>
				</div>
				<Input field=chance help="evaluation" value={100 - evaluation.chance} type=number disabled/>
			<!-- 3rd line: MASTER ONLY info on rolled and resulting success tier, D100 roll button -->
				<input id=rolled type=text value={activity?.rolled} class="text doublespan" placeholder="Wurf" onclick={(e) => e.target.select()}>
				<input id=success data-help="successtier" type=text value={revision?.succ ?? ((revision?.shift) ? ((revision.shift > 0) ? `+${revision.shift}` : revision.shift) : null) ?? null} class="text centered" placeholder={activity?.success ?? "succ"}/>
			{/if}
		</div>
		<!-- next lines: inflict, D100 roll button -->
		{#if activity?.begin}
			<div class="progress" onclick={show_card}>
				<div>{(activity) ? timestamp(activity.begin) : "von"}</div>
				<div class="progress-bar">
					<div class="progress-indicator" style="background: linear-gradient(to right, {actcolor} {progress}%, transparent {progress}%)"></div>
					<div class="progress-bar-background"></div>
				</div>
				<div>{(activity) ? timestamp(activity.end - 1) : "bis"}</div>
			</div>
		{/if}
		<div id="inflicts" class="actdata">
			{#each schedule as item}
				<p title={item.ID}>{timestamp(item.time)}</p>
				<p>{item.text}</p>
				{#if item.btn === 'rollSC'}
					<button type="button" class="button miniButton" onclick={second_roll.bind(null, item.ID)}>
							<img class="buttonImage" src="/static/buttons/D100_old.png" alt="W100" />
					</button>
				{:else if item.btn === 'rolled'}
					<button type="button" class="button miniButton" disabled>
							<img class="buttonImage" src="/static/buttons/D100_old.png" alt="W100" />
					</button>
				{:else if item.btn === 'shorten'}
					<button type="button" class="button miniButton" onclick={shorten_path.bind(item, item.index)}>
						<div class="fa icon-scissors"></div>
					</button>
				{:else}
					<p></p>
				{/if}
			{/each}
		</div>
		<!-- last line: start/stop button -->
		{#if submit}
			<button id=submitBtn data-help="action" class="btn-primary" disabled={!submit} onclick={submit_activity} >
				{submit}
			</button>
		{/if}
	</div>
</fieldset>

<datalist id="fighterList"></datalist>


<script>
		import { user, game, view, send_request, handle_error} from "../client.svelte.js";
		import {protoActions, timestamp, noAction, calc_activityColor, successText} from "../core.js";
		import {show_actionCard, Option} from "../dialogs/OptionDialog.svelte";
		import ActionSelect from "./ActionSelect.svelte";
		import Input from "../elements/Input.svelte";

	// component state variables
    let activity = $derived(game.activities.get(view.persona?.activity) ?? null)
		let revision = $derived(game.infos.get(activity?.revision) ?? null)
    let stunned = $derived(view.persona.isStunned)
    let evaluation = $derived(activity?.evaluation ?? {pro: 0, con: 0, mod: 0, bon: 0, change: 0})
    let actcolor = $derived((stunned) ? '#444' : (activity?.action) ? calc_activityColor(activity?.action) : 'unset')
    let schedule = $derived.by(compose_schedule)
    let amends = $derived((activity?.amends ?? []).map(effID => game.effects.get(effID) ?? {name: effID.classname, kind: null, summary: ""}))
    let order = $state({})  //ToDo: use view.order to start new order
		let roll = $derived((activity?.amends?.find(effID => ['Advantage', 'TakeBest'].includes(effID.split(" ")[0])) && activity.rolls.length > 1) ? activity.rolls[1] : activity.rolls[0])

	// derived state variables
    let progress = $derived((activity) ? Math.round(Math.min(Math.max(0, (game.time - activity.begin) / activity.dur * 100), 100)) : 0)
    let submit = $derived.by( () => {
			if (stunned && !user.isMaster)
				return null
			if (!activity) {
			  const action = protoActions[order.action]
			  if (action?.aiming?.selfish || order.aim)
				  return "START"
		  } else if (activity.state === 'pending')
		    return "REVOKE"
      else if (['pending', 'started', 'progressing'].includes(activity.state) || user.isMaster)
				return "STOP"
      return ""
    })

    // $inspect(`ACTIVITY - submit:`, submit)


    /** ToDo: internal communication
     * action
     * aim from click on map
     */

		/*** state evaluation functions ***/

		function show_card(e) {
				console.log(`ACTIONCARD - show`, activity.action)
				show_actionCard(activity.action, 'map')
		}

    function compose_schedule() {
        // compose inflicts list from activity data inflicts
        if (!activity) return []
        let newsched = []
        // add all incidents (data should be in timeline) to the schedule
        let inflict  // keep var
        const hasSecondChance = activity?.amends?.find(effID => ['Advantage', 'TakeBest'].includes(effID.split(" ")[0]))
        const itinerary = (activity.itinerary ?? [])
                .map((transit,index) => Object.assign({}, transit, {time: transit.arrival, text: `Ankunft bei ${transit.waypoint}`, ZUB: 'Transit', index: index}))
                .filter(incid => activity.state === 'pending' || incid.index > activity.leg)
        const inflicts = activity.implics
                .map(infoID => game.infos.get(infoID))
                .filter(info => info && ['Inmotion', 'Inflict', 'Intensify'].includes(info.ZUB) && ['upcoming', 'ongoing'].includes(info.status))
        const incidents = itinerary.concat(inflicts)
        for (const [index,inflict] of incidents.entries()) {
            if (!inflict) {
                handle_error(`ActivityBox: Inflict (at index ${index}) could not be found in timeline`)
                continue
            }
            let text = (inflict.rolled && inflict.ZUB !== 'Inmotion') ?
		            `${successText[inflict.succCat]} auf ${inflict.target}: ${inflict.coding.effects}` :
		            inflict.text.split("_")[0]
            if (inflict.target && game.personas.has(inflict.target) && inflict.target !== activity.aim && !['Inmotion', 'Transit'].includes(inflict.ZUB))
                text = `${inflict.target}: ${text}`
            if (user.isMaster && inflict.result && inflict.success > 0) text += ` (${inflict.result})`
            const btn = (hasSecondChance && activity.rolls?.length === 1 && (inflict.timing === 'main' || inflict.timing === 'turn')) ? 'rollSC' :
                        (hasSecondChance && activity.rolls?.length > 1 && (inflict.timing === 'main' || inflict.timing === 'turn')) ? 'rolled' :
                        (['Transit', 'Inmotion'].includes(inflict.ZUB) && incidents.length > 1) ? 'shorten' : ''
            newsched.push({ID: inflict.ID, time: inflict.time, text: text, index: inflict.index ?? activity.leg,  btn: btn})
        }
        // add closing entry if no incident at end
        // if (activity && (!inflict || inflict.time < activity.end - 1))
        //     newsched.push({time: activity.end - 1, text: "Ende dieser Handlung"})
        return newsched.sort((a,b) => a.time - b.time)
		}


		/** Send change request for current activity to server`
     *
     * @param e event that is triggered by the change
     */
		function change_activity({target: {id, value}}) {
				console.log(`ACTIVITY: change ${id} to ${value}`)
				const attrib = id
				const newval = (['dur', 'bon', 'rolled'].includes(attrib)) ? Number(value) : value
				const action = (attrib === 'action') ? newval : order.action
				if (activity?.ID && user.isMaster) {
					// check if combination of action and aim is valid
					console.log(`ACTIVITY: Master changes activity attribute: ${attrib} = ${newval}`)
					send_request('revise', {actID: activity.ID, attrib: attrib, value: newval}, "Master changes activity attribute")
				} else if (!activity) {
					order[attrib] = newval
					const actionData = protoActions[action] ?? noAction
					if ((actionData.aiming && actionData.aiming.selfish) || order.aim) {
						submit = "START"
					} else if (attrib === 'action')
						order = new Option(action)
					console.log(`ACTIVITY: Compose order attrib ${attrib} to ${newval}: `, order)
				}
		}

    function select_action(e) {
        // console.log(`Action ${e.target.value} has been selected`)
		}

    function shorten_path(itinIndex) {
        send_request('alter', {action: 'SHORTEN', actID: activity.ID, aim: itinIndex}, `Shorten path for step ${itinIndex} of the itinerary`)	// aim specifies the leg which is to be cut
		}

    function second_roll(inflID) {
        send_request('alter', {action: 'ROLL', actID: activity.ID, attrib: 'ROLL', value: inflID}, `Use Second Chance for ${inflID}`)
		}

    function submit_activity(e) {
        if (game.time === 0) return
        if (submit === 'START')
            game.place_order(order)
        else if (submit === 'REVOKE')
            game.revoke_order(view.persona.ID, activity.ID)
        else if (submit === 'STOP')
            game.stop_activity(view.persona.ID, activity.ID)
        if (action instanceof Event) {  // might be called by click-event
            if (action.target.id === "submitBtn") {
                console.debug("Unnecessary getElementByIDs")
                // action = document.getElementById("action").value
                // aim = document.getElementById("aim").value
                // dur = Number(document.getElementById("dur").value)
            }
        }
		}

		function revise_activity(e) {
        e.preventDefault()
				if (user.isMaster) {
						const coord = {x: e.clientX, y: e.clientY}
						const revisions = [
							{label: "vorteilhafte Situation", coding: "Advantage"},
							{label: "sicherer Treffer", coding: "Sure"},
							{label: "abgelenkt", coding: "Distract"}]
            revisions.forEach(rev => Object.assign(rev, {actID: activity.ID, socket: 'revise'}))
						console.log(`ACTIVITY: Show menu to amend activity with `, revisions)
						view.show_dialog('options', {coord: coord, options: {Revision: revisions}})
				}
		}

		function check_aim(e) {
				let newAim = e.target.value
				console.log('ACTIVITYBOX - new aim has been entered', newAim)
				if (!game.personas.has(newAim)) {
						newAim = newAim.toLowerCase()
						if (game.personas.has(newAim))
								e.target.value = newAim
						newAim = newAim.toUpperCase()
						if (game.personas.has(newAim))
								e.target.value = newAim
				}
		}
</script>

<style lang="sass">
	@use "../colors" as colors

	.rollBox
		position: absolute
		left: 20px
		top: 5px
		width: 80px

	.rollBox img
		width: 100%

	.roll
		position: absolute
		left: 12px
		top: 9px
		color: black
		font-size: 20pt
		font-weight: bold
		letter-spacing: 0.9em
		opacity: 75%

		&.tight
			letter-spacing: 0.2ch

	.locked
		pointer-events: none

	#submitBtn
		width: 100%
		height: 32px
		display: block
		margin: 0 auto
		text-align: center

	//.activityarea
	//	position: relative
	//	border-radius: 10px
	//	border: 2px solid black
	//	box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)
	//	margin: 6px
	//	break-inside: avoid

	.amends
		position: absolute
		right: 4px
		top: 8px
		//width: 260px
		display: flex
		justify-content: flex-end
		gap: 16px

	//.activity
	//	color: lightgray

	.dur
		width: 2em
		margin-right: 4px
		text-align: right

	#evaluation
		display: grid
		grid-template-columns: repeat(4, 3ch 1ch)
		justify-content: space-around
		justify-items: center

	#evaluation span
		align-self: center

	#inflicts
		display: grid
		justify-content: center
		grid-gap: 5px
		margin: 5px
		grid-template-columns: 4ch 1fr 4ch

	.miniButton img
		width: 100%
		margin-top: 2px

	.progress
		display: flex
		flex-flow: row nowrap
		gap: 5px
		padding: 10px 0

	.progress-bar
		position: relative
		overflow: hidden
		width: 100%

	.progress-indicator,
	.progress-bar-background
		position: absolute
		top: 0
		left: 0
		width: 100%
		height: 100%
		display: flex
		align-items: center
		justify-content: center

	.progress-indicator
		z-index: 1

	.progress-bar-background
		background: colors.$grey-30
		box-shadow: inset 0 2px 6px rgba(0, 0, 0, 0.3)

</style>
